import axiosInstance from "../api/axios";

/* ---------------- Interior-designer plan configuration (Zumale admin) ----------------
 * One row with no interiorDesignerId is the GLOBAL DEFAULT every designer inherits; a row naming a
 * designer is a negotiated override whose blank fields fall back to that default.
 *
 * `phaseFeeDivisor` and `minPortfolioItems` are GLOBAL-only — the backend always writes them to the
 * default row, whatever scope is being edited. A per-designer divisor would make the same project
 * phase cost two designers different amounts.
 */

export const listIdPlanConfigs = () => axiosInstance.get(`/admin/id-plus/configs`);

export const upsertIdPlanConfig = (body) => axiosInstance.put(`/admin/id-plus/configs`, body);

export const deleteIdPlanConfig = (configId) => axiosInstance.delete(`/admin/id-plus/configs/${configId}`);

// Preview the numbers a designer actually resolves to, plus which of them are inherited.
export const getEffectiveIdPlanConfig = (interiorDesignerId) =>
  axiosInstance.get(`/admin/id-plus/configs/effective`, { params: { interiorDesignerId } });

/* ---------------- Designer subscriptions ----------------
 * The roster includes designers with no subscription and designers who have only asked for one, so
 * the whole funnel — request, activation, billing, arrears — is on a single screen.
 */

export const listIdSubscriptions = (params) => axiosInstance.get(`/admin/id-plus/subscriptions`, { params });

// Also approves any open request for that designer.
export const upsertIdSubscription = (body) => axiosInstance.put(`/admin/id-plus/subscriptions`, body);

export const rejectIdDiscoveryRequest = (interiorDesignerId, comment) =>
  axiosInstance.patch(`/admin/id-plus/subscriptions/${interiorDesignerId}/reject`, { comment });

// Ends the subscription: the designer stops appearing to buyers on BuildVizer projects. Their
// account, leads and live executions are untouched.
export const deactivateIdSubscription = (interiorDesignerId) =>
  axiosInstance.patch(`/admin/id-plus/subscriptions/${interiorDesignerId}/deactivate`);

// Records the payment AND issues the signed receipt — one action, because it is one event.
export const recordIdInstallmentPayment = (installmentId, body) =>
  axiosInstance.post(`/admin/id-plus/installments/${installmentId}/payment`, body);

/* ---------------- Designer-facing ----------------
 * No payment gateway exists in this product, so "subscribe" raises a request that Zumale admin
 * prices and activates — the same contract designers already know from phase applications.
 */

export const getMyDiscoveryStatus = () => axiosInstance.get(`/id-plus/my/discovery`);

export const requestDiscovery = (body) => axiosInstance.post(`/id-plus/my/discovery`, body || {});
